import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
import { BatchApiAdapter } from '../adapters/BatchApiAdapter';
import type { BatchFilters } from '../models/Batch';

export const useBatches = (filters: BatchFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new BatchApiAdapter(httpClient);

  const defaultFilters: BatchFilters = {
    sortBy: 'created_at',
    sortDirection: 'desc',
    ...filters,
  };

  const { data, isLoading, isFetching, error, fetchNextPage, hasNextPage, isFetchingNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ['batches', defaultFilters],
      queryFn: ({ pageParam = 1 }) =>
        adapter.getBatchesPaginated({
          ...defaultFilters,
          page: pageParam,
        }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) => lastPage.nextPage,
      staleTime: 2 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
      placeholderData: (previousData) => previousData,
    });

  const batches = data?.pages.flatMap((page) => page.batches) ?? [];
  const total = data?.pages[data.pages.length - 1]?.total ?? 0;

  return {
    batches,
    isLoading,
    isFetching,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    total,
  };
};
